/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum CriterionCodeEnum {
    COMPLAINT_NUMBER = 'COMPLAINT_NUMBER',
    SETTLEMENT_NUMBER = 'SETTLEMENT_NUMBER',
    BUNDLE_NUMBER = 'BUNDLE_NUMBER',
    TE_MINUTES_BUNDLING = 'TE_MINUTES_BUNDLING',
    TIME_PERIOD = 'TIME_PERIOD',
    PERIOD_TOTAL_AMOUNT = 'PERIOD_TOTAL_AMOUNT',
    SETTLEMENT_TOTAL_AMOUNT = 'SETTLEMENT_TOTAL_AMOUNT',
    PERIOD_TYPE = 'PERIOD_TYPE',
    BUNDLE_STATUS = 'BUNDLE_STATUS',
    SUPPLIER = 'SUPPLIER',
}
